import { getApiEndpoint } from '../appconfig';

export const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const randomColor = [
  '#7887c9',
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#ffc107',
];

export const randomTopicColor = [
  '#fdecec',
  '#c1dfdc',
  '#fef7d9',
  '#fde8d5',
  '#dbf3f8',
  '#fdecec',
];

export const devBuildPathQuestion = {
  paths: [
    {
      params: {
        questionId: 'test-this-video-logic-2029599',
      },
    },
  ],
  fallback: 'blocking',
};

export const productionBuildPathQuestion = {
  paths: [
    {
      params: {
        questionId: 'can-we-do-butterfly-squats-during-pregnancy-932611',
      },
    },
  ],
  fallback: 'blocking',
};

export const checkApiIsDev = () =>
  getApiEndpoint() == 'https://dev-api.myloapp.in/';

export const question_views_add_on = 2000;
export const follow_add_on = 100;
